import { useEffect, useRef } from 'react';

export const useOutsideClick = <T extends HTMLElement, R = void>(
  callback: (event: MouseEvent) => R,
) => {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback(event);
      }
    };

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [callback]);

  return ref;
};
